/* Balkan — navigatia: mega-menu de desktop + sertarul de mobil.

   Scriptul e chemat si din `balkan-nav.liquid`, si din `balkan-nav-drawer.liquid`,
   deci se poate insera de doua ori in aceeasi pagina. De-aia santinela de mai jos:
   un al doilea <script src> identic chiar se executa a doua oara.               */
(() => {
  if (window.__bkNavReady) return;
  window.__bkNavReady = true;

  const mq = window.matchMedia('(min-width: 1280px)');
  const cache = new Map();

  /* ------------------------------------------------------------------ MEGA */

  /* Panoul e `position: fixed` si are nevoie de marginea de jos a header-ului.
     O citim din DOM, nu o presupunem: bara de anunturi isi schimba inaltimea la
     redimensionare, iar header-ul e lipit (sticky). */
  const syncTop = () => {
    // #header-group e un wrapper de inaltime 0 (header-ul dinauntru e sticky),
    // deci bounding rect-ul lui da 0. Elementul real e #header-component.
    const header = document.querySelector('#header-component') || document.querySelector('#header-group');
    if (!header) return;
    const r = header.getBoundingClientRect();
    const bottom = Math.max(0, Math.round(r.height > 0 ? r.bottom : 0));
    if (bottom === 0) return;
    document.documentElement.style.setProperty('--bkmega-top', bottom + 'px');
  };

  const nav = document.querySelector('[data-bk-nav]');
  if (nav) {
    const groups = [...nav.querySelectorAll('[data-bk-group]')];

    const close = (g) => {
      const btn = g.querySelector('[data-bk-toggle]');
      const panel = g.querySelector('[data-bk-panel]');
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      g.classList.remove('is-open');
    };
    const closeAll = (except) => groups.forEach((g) => { if (g !== except) close(g); });

    const open = (g) => {
      syncTop();
      closeAll(g);
      const btn = g.querySelector('[data-bk-toggle]');
      const panel = g.querySelector('[data-bk-panel]');
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      g.classList.add('is-open');
    };

    groups.forEach((g) => {
      const btn = g.querySelector('[data-bk-toggle]');
      const panel = g.querySelector('[data-bk-panel]');
      let leaveTimer = null;
      const cancel = () => { if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; } };

      // hover, dar numai pe desktop si cu un mic ragaz la iesire, ca diagonala
      // dintre buton si panou sa nu inchida meniul din greseala
      g.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch' || !mq.matches) return;
        cancel(); open(g);
      });
      g.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'touch' || !mq.matches) return;
        cancel(); leaveTimer = setTimeout(() => close(g), 180);
      });

      /* Pe un dispozitiv cu mouse, `pointerenter` a deschis deja panoul pana
         cand degetul apasa. Daca aici am comuta, clicul l-ar INCHIDE imediat —
         exact invers fata de ce asteapta omul. Deci pe desktop clicul doar
         deschide; inchiderea ramane pe iesirea mouse-ului si pe Escape.
         Pe touch, unde nu exista hover, clicul comuta normal. */
      const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      btn.addEventListener('click', (e) => {
        cancel();
        /* Pe desktop intrarea e un LINK catre colectia grupului: hover-ul a
           deschis deja panoul, deci clicul trebuie sa NAVIGHEZE, nu sa comute.
           Pe atingere nu exista hover, deci primul tap deschide panoul (si
           opreste navigarea), al doilea tap pe acelasi link duce la colectie. */
        if (hoverCapable && mq.matches) { open(g); return; }
        if (!g.classList.contains('is-open')) { e.preventDefault(); open(g); return; }
        close(g);
      });

      // focusul iese complet din grup -> inchide (tastatura)
      g.addEventListener('focusout', () => {
        setTimeout(() => { if (!g.contains(document.activeElement)) close(g); }, 0);
      });

      /* ---- selectia categoriei, incarcata la cerere ---- */
      const slot = panel.querySelector('[data-bk-prevslot]');
      const rail = [...panel.querySelectorAll('[data-bk-cat]')];

      // prima categorie e randata din server: o punem in cache ca sa nu o recerem
      if (rail[0]) cache.set(rail[0].dataset.bkCat, slot.innerHTML);

      let seq = 0;
      const preview = async (a) => {
        const handle = a.dataset.bkCat;
        rail.forEach((x) => x.classList.toggle('is-current', x === a));

        if (cache.has(handle)) { slot.innerHTML = cache.get(handle); return; }

        const mine = ++seq;
        slot.innerHTML = '<div class="bknav__skel"></div>'.repeat(6);
        try {
          const r = await fetch(`/collections/${handle}?section_id=balkan-menu-fragment`);
          const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
          const frag = doc.querySelector('[data-bk-menufrag]');
          const html = frag ? frag.innerHTML : '';
          cache.set(handle, html);
          if (mine === seq) slot.innerHTML = html;          // hover rapid: doar ultima cerere conteaza
        } catch {
          if (mine === seq) slot.innerHTML = '';            // reteaua a picat: railul ramane navigabil
        }
      };

      rail.forEach((a) => {
        a.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'touch') preview(a); });
        a.addEventListener('focus', () => preview(a));
      });
    });

    addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(null); });
    addEventListener('scroll', syncTop, { passive: true });
    addEventListener('resize', syncTop);
    syncTop();
  }

  /* ---------------------------------------------------------------- SERTAR */

  const drawer = document.querySelector('[data-bk-drawer]');
  if (drawer) {
    /* In referinta, bara neagra de anunturi ramane vizibila deasupra sertarului.
       Ii citim inaltimea reala din DOM — se schimba la redimensionare si nu se
       poate presupune. Daca bara lipseste, sertarul incepe de sus. */
    const syncDrawerTop = () => {
      const bar = document.querySelector('.bk-marquee--top, [data-bk-announce]');
      const h = bar ? Math.max(0, Math.round(bar.getBoundingClientRect().bottom)) : 0;
      document.documentElement.style.setProperty('--bkdrawer-top', h + 'px');
    };
    addEventListener('resize', syncDrawerTop);
    addEventListener('scroll', syncDrawerTop, { passive: true });
    syncDrawerTop();
    const burger = drawer.querySelector('[data-bk-open]');
    const panel = drawer.querySelector('[data-bk-drawerpanel]');
    const scrim = drawer.querySelector('[data-bk-scrim]');
    const closeBtn = drawer.querySelector('[data-bk-close]');
    let lastFocus = null;

    const setOpen = (on) => {
      if (on) syncDrawerTop();
      panel.hidden = !on;
      scrim.hidden = !on;
      burger.setAttribute('aria-expanded', String(on));
      document.documentElement.classList.toggle('bk-noscroll', on);
      if (on) {
        lastFocus = document.activeElement;
        requestAnimationFrame(() => { panel.classList.add('is-in'); closeBtn.focus(); });
      } else {
        panel.classList.remove('is-in');
        if (lastFocus) lastFocus.focus();
      }
    };

    burger.addEventListener('click', () => setOpen(panel.hidden));
    closeBtn.addEventListener('click', () => setOpen(false));
    scrim.addEventListener('click', () => setOpen(false));
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) setOpen(false); });
    // trecerea pe desktop cu sertarul deschis ar lasa pagina blocata
    mq.addEventListener('change', (e) => { if (e.matches && !panel.hidden) setOpen(false); });

    /* ---- al doilea nivel: categoriile unui grup ----
       Referinta (aronia charlottenburg) deschide un panou care intra peste
       primul, cu buton de intoarcere — nu un acordeon. Asa lista de nivel 1
       ramane scurta si se vede toata fara derulare. */
    const subs = [...panel.querySelectorAll('[data-bk-subpane]')];
    const openers = [...panel.querySelectorAll('[data-bk-sub]')];

    const closeSubs = () => {
      subs.forEach((s) => { s.classList.remove('is-in'); s.hidden = true; });
      openers.forEach((o) => o.setAttribute('aria-expanded', 'false'));
      panel.classList.remove('has-sub');
    };

    openers.forEach((o) => o.addEventListener('click', () => {
      const pane = subs.find((s) => s.dataset.bkSubpane === o.dataset.bkSub);
      if (!pane) return;
      closeSubs();
      pane.hidden = false;
      o.setAttribute('aria-expanded', 'true');
      panel.classList.add('has-sub');
      requestAnimationFrame(() => {
        pane.classList.add('is-in');
        const back = pane.querySelector('[data-bk-back]');
        if (back) back.focus();
      });
    }));

    panel.querySelectorAll('[data-bk-back]').forEach((b) => b.addEventListener('click', () => {
      const pane = b.closest('[data-bk-subpane]');
      closeSubs();
      const opener = openers.find((o) => o.dataset.bkSub === pane.dataset.bkSubpane);
      if (opener) opener.focus();
    }));

    // Escape: intai al doilea nivel, apoi sertarul
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (panel.classList.contains('has-sub')) { e.stopPropagation(); closeSubs(); }
    });

    // sertarul se inchide de fiecare data cand se deschide altceva peste el
    panel.addEventListener('click', (e) => {
      if (e.target.closest('[data-bk-fav-open], [data-bk-srch-open]')) setOpen(false);
    });

    // la inchidere revenim mereu la primul nivel
    scrim.addEventListener('click', closeSubs);
    closeBtn.addEventListener('click', closeSubs);
  }
})();
